import type React from 'react';

function DeutschePostLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 488.16 84.93"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Deutsche Post Logo</title>

      <g id="svg1898">
        <g id="layer1">
          <g id="g2038">
            <g id="g2017">
              <polygon
                id="_225737648"
                data-name=" 225737648"
                points="416.01 70.36 430.26 70.36 415.86 84.93 401.61 84.93 416.01 70.36"
              />

              <polygon
                id="_229043400"
                data-name=" 229043400"
                points="396.78 70.36 411.03 70.36 396.64 84.93 382.38 84.93 396.78 70.36"
              />

              <polygon
                id="_226455448"
                data-name=" 226455448"
                points="447.83 70.36 433.57 70.36 447.97 84.93 462.23 84.93 447.83 70.36"
              />

              <polygon
                id="_227904456"
                data-name=" 227904456"
                points="467.06 70.36 452.8 70.36 467.2 84.93 481.46 84.93 467.06 70.36"
              />

              <path
                id="path2012"
                d="M458.32,29.93c2.47-6.74,4.19-16.99,4.55-24.16l25.29,6.29c-2.03,29.69-24.29,55.69-57.33,55.68-37.37-.02-51.81-32.5-49.87-57.12l10.97-3.49c-1.78,14.01,2.55,24.11,5.54,28.74C393.92,16.05,408.88,.01,427.61,0c16.84-.01,30.77,12.29,30.71,29.93h0Zm-50.9,.62h0c0,11.18,9.06,20.25,20.25,20.25s20.24-9.06,20.24-20.25-9.06-20.24-20.24-20.24-20.25,9.06-20.25,20.24Z"
              />
            </g>

            <g id="g2024">
              <path
                id="_228277928"
                data-name=" 228277928"
                d="M10.77,22.51H0v45.05H9.36c14.71,0,22.33-8.78,22.33-22.91,0-9.81-3.62-15.82-8.52-18.97-2.96-1.94-6.77-3.16-12.39-3.16h0Zm-.7,5.62c10.19,0,14.26,6.9,14.26,16.52,0,10.71-4.65,17.29-14.26,17.29h-3.1V28.12h3.1Z"
              />

              <path
                id="_140087096"
                data-name=" 140087096"
                d="M62.59,52.91v-2.26c0-11.62-5.1-16.65-12.39-16.65-8.33,0-13.23,7.1-13.23,17.23s4.65,16.78,14.33,16.78c4.06,0,7.42-1.03,9.55-2l-.33-5.62c-1.68,1.23-4.32,2.65-8.13,2.65-6.13,0-8.71-3.49-8.71-10.13h18.91Zm-6.58-4.59h-12.33c.07-6.06,2.52-9.55,6.32-9.55,4,0,6,3.22,6,9.55h0Z"
              />

              <path
                id="_140081624"
                data-name=" 140081624"
                d="M93.7,67.56c-.13-1.94-.26-4.13-.26-6.32v-26.79h-6.71v19.42c0,5.1-1.93,8.52-6.19,8.52-3.42,0-5.1-2.2-5.1-7.36v-20.59h-6.71v22.14c0,6.97,3.03,11.42,9.68,11.42,4.52,0,6.97-2.39,8.59-5.49h.13c0,.97,.25,4.2,.25,5.04h6.33Z"
              />

              <path
                id="_227263352"
                data-name=" 227263352"
                d="M117.13,67.04v-5.04c-.84,.39-1.87,.78-3.23,.78-2.39,0-3.48-1.23-3.48-4.84v-18.33h6.71v-5.16h-6.71v-8.78l-6.71,2v6.78h-5.3v5.16h5.3v19.69c0,6.39,3.03,8.71,8.45,8.71,1.94,0,3.74-.45,4.97-.97h0Z"
              />

              <path
                id="_224935040"
                data-name=" 224935040"
                d="M141,58c0-4-2.39-6.13-6.39-8.39l-2.9-1.61c-2.9-1.61-4.64-2.71-4.64-4.91,0-2.32,1.61-3.87,4.96-3.87,2.71,0,4.97,.65,6.78,1.42l.32-5.42c-1.35-.52-4.13-1.23-7.62-1.23-6.71,0-11.03,4.52-11.03,9.49,0,4.71,2.64,6.91,6.71,8.91l3.48,1.74c2.97,1.48,3.87,2.97,3.87,4.71,0,2.58-2.26,3.93-5.74,3.93-3.23,0-6.13-1.36-8-2.32l-.39,5.81c2.06,.97,5.36,1.74,9.1,1.74,7.43,0,11.49-4.13,11.49-10h0Z"
              />

              <path
                id="_138505344"
                data-name=" 138505344"
                d="M168.3,66.65l-.39-5.68c-1.48,.84-3.87,1.68-6.13,1.68-5.75,0-9.04-4.52-9.04-11.42,0-8.01,3.23-11.87,8.91-11.87,2.39,0,4.33,.7,5.94,1.55l.32-5.61c-1.61-.71-4.32-1.29-6.71-1.29-10.2,0-15.43,7.1-15.43,17.17,0,9.36,4.71,16.84,15.1,16.84,2.84,0,5.68-.65,7.42-1.35h0Z"
              />

              <path
                id="_140175464"
                data-name=" 140175464"
                d="M198.11,67.56v-22.14c0-6.97-3.03-11.42-9.68-11.42-4.39,0-6.77,2.45-8.2,4.84h-.13V19.15h-6.71v48.4h6.71v-19.62c0-5.1,2.13-8.33,6.33-8.33,3.42,0,4.97,2.2,4.97,7.36v20.59h6.71Z"
              />

              <path
                id="_140088704"
                data-name=" 140088704"
                d="M230.06,52.91v-2.26c0-11.62-5.1-16.65-12.39-16.65-8.32,0-13.23,7.1-13.23,17.23s4.65,16.78,14.33,16.78c4.07,0,7.42-1.03,9.55-2l-.33-5.62c-1.68,1.23-4.32,2.65-8.13,2.65-6.13,0-8.71-3.49-8.71-10.13h18.91Zm-6.58-4.59h-12.33c.06-6.06,2.51-9.55,6.32-9.55,4,0,6,3.22,6,9.55h0Z"
              />

              <path
                id="_229157152"
                data-name=" 229157152"
                d="M277.5,35.74c0-4.13-1.23-7.42-3.55-9.68-2.39-2.32-5.55-3.55-10.13-3.55h-11.87v45.05h6.97v-18.26h4.2c9.42,0,14.39-4.91,14.39-13.55h0Zm-15.43-7.74c5.48,0,8.33,2.45,8.33,8,0,4.97-2.39,7.81-8.39,7.81h-3.1v-15.81h3.16Z"
              />

              <path
                id="_224862128"
                data-name=" 224862128"
                d="M307.51,50.97c0-11.94-6.19-16.97-13.94-16.97s-13.94,5.03-13.94,16.97,6.2,17.04,13.94,17.04,13.94-4.9,13.94-17.04Zm-6.97,0c0,6.9-1.81,12.01-6.97,12.01s-6.97-5.1-6.97-12.01,1.81-11.94,6.97-11.94,6.97,5.04,6.97,11.94h0Z"
              />

              <path
                id="_224865032"
                data-name=" 224865032"
                d="M332.87,58c0-4-2.39-6.13-6.39-8.39l-2.9-1.61c-2.9-1.61-4.65-2.71-4.65-4.91,0-2.32,1.62-3.87,4.97-3.87,2.71,0,4.97,.65,6.77,1.42l.32-5.42c-1.36-.52-4.13-1.23-7.61-1.23-6.71,0-11.04,4.52-11.04,9.49,0,4.71,2.65,6.91,6.71,8.91l3.48,1.74c2.97,1.48,3.88,2.97,3.88,4.71,0,2.58-2.26,3.93-5.75,3.93-3.22,0-6.13-1.36-8-2.32l-.39,5.81c2.07,.97,5.36,1.74,9.1,1.74,7.42,0,11.49-4.13,11.49-10h0Z"
              />

              <path
                id="_23879864"
                data-name=" 23879864"
                d="M354.03,67.04v-5.04c-.84,.39-1.87,.78-3.23,.78-2.39,0-3.48-1.23-3.48-4.84v-18.33h6.71v-5.16h-6.71v-8.78l-6.71,2v6.78h-5.29v5.16h5.29v19.69c0,6.39,3.03,8.71,8.46,8.71,1.94,0,3.74-.45,4.97-.97h0Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default DeutschePostLogo;
